export const BLOG_CATEGORIES = [
  'Visa Guides',
  'Passport Tips',
  'Travel Tips',
  'Country Info',
  'General',
] as const;

export type BlogCategory = (typeof BLOG_CATEGORIES)[number];
